import React from 'react';
import { Enum, EnumBaseInstance } from 'model-core';

class JettyContactsEnum extends Enum {}
class JettyContactsEnumInstance extends EnumBaseInstance {}

const JettyContacts = new JettyContactsEnum(
  {
    EMAIL_HELP: {
      displayName: 'help@jetty.com',
      href: 'mailto:help@jetty.com',
      Link: () => (
        <a href={JettyContacts.EMAIL_HELP.href}>
          {JettyContacts.EMAIL_HELP.displayName}
        </a>
      ),
    },
  },
  JettyContactsEnumInstance
);

export default JettyContacts;
